export const DISCOUNT_END_TIME_STORAGE_KEY = "discountEndTime";

export const TWO_DAYS_MS = 48 * 60 * 60 * 1000;

export const COUNTDOWN_INTERVAL = 1000;

export interface ITimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export interface IDiscountTimeParams {
    discountEndDateFromSettings?: string;
    discountEndTime?: string;
}

export const ZERO_TIME_LEFT: ITimeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
};

// Date format is YYYY-MM-DD
// function will return true on start & end date as well
export const DISCOUNT_START_DATE = "2025-11-10";
export const DISCOUNT_END_DATE = "2025-12-31";
